@import "../../../common/_base";
@import "./test-action-group-styles.scss";
@import "./test-grid-styles.scss";

@include box-sizing();

ch-test-flexible-layout {
  display: contents;

  .welcome-message {
    margin-block-start: var(--spacing--l, var(--mer-spacing--md));
    text-align: center;
    font-size: 64px;
    line-height: 80px;
    opacity: 0.75;
  }
}

ch-action-group-render {
  padding-inline: var(--mer-spacing--sm, 12px);

  &::part(separator) {
    background-color: currentColor;
    margin-block: var(--mer-spacing--2xs, var(--spacing--xs));
  }
}

.flexible-layout {
  &::part(leaf inline) {
    background-color: var(--mer-surface__elevation--01);
  }

  &::part(tab-list block) {
    overflow: auto;
  }

  // - - - - - - - - - - - - - - - -
  //          Drag preview
  // - - - - - - - - - - - - - - - -
  // &::part(drag-preview-element button block) {
  //   padding-inline: 25px;
  // }

  // &::part(drag-preview--outside-tab-list) {
  //   box-shadow: 0 3px 4px 1px #00000020;
  // }
}
